import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({


  state: {


    isUserAcceptedCookies : false,
    isUserAcceptedCookiesAnswered : false,
    isGAEnabled : false,


    unlockProgress : 0,

    isMobile : false,
    currentHeight : 0,


    isShowScreenBlock : true,
    isShowScreenBlockWithLoading : false,

    isShowLanding : true,

    isShowLandingChapter1 : false,
    isShowComicChapter1 : false,
    isShowComicChapter2 : false,
    isShowComicChapter3 : false,
    isShowHome : false,

    chapter1CollectedPrime : {
      "E" : false,
      "K" : false,
      "P" : false,
      "R" : false,
      "W" : false,
    },
    

    isFinishedComic : {
      chapter1 : false,
      chapter2 : false,
      chapter3 : false,
    },



    isShowCookiesAcceptanceMessage : false,

    isInitializedAudio : false,

    
    manualStoppedMusic : false,

    isAlreadyUnlockedChapter1 : false,
    isAlreadyUnlockedChapter2 : false,

    audioContext : null,
    audioBuffer : {},
    audioSource : {},
    playingAudio : "",


    


    imageMode : "webp",
    imagePath : {
      "normal" : 'static/images',
      "webp" : 'static/webpFolder/images',
    },
    imageExtension : {
      "jpg" : {
        "normal" : "jpg",
        "webp" : "webp",
      },
      "png" : {
        "normal" : "png",
        "webp" : "webp",
      }
    },


    pageLeavingOnceEvent : null,
    
    pageLeavingEvent : {
      "home" : null,
      "comic" : null,
      "leaderboard" : null,
      "faq" : null,
    },


    //firebase
    firebaseApp : null,
    firebaseAuth : null,
    firebaseDb : null,
    isFirebaseLoaded : false,

    // account
    account : null,
    discordId : null,
    walletAddress : null,

    accountErrorMessageText : null,

    isShowAccountConnectForm : false,
    isShowAccountLoginForm : false,
    isShowAccountInfo : false,
    isShowAccountForgetPasswordForm : false,
    isShowAccountLogoutConfirm : false,
    isShowAccountUnlinkDiscordConfirm : false,
    isShowAccountUnlinkWalletConfirm : false,

    creatingAccountEmail : "",
    creatingAccountPassword : "",
    isShowCreateAccountForm : false,
    isShowAccountEmailVerify : false,
    resendEmailVerifyCounting : 0,
    sendEmailVerifyEvent : null,
    resendEmailVerifyEvent : null,



    


    // //recaptcha
    // //DEV
    // recaptchaKey : "6Ld_OqUeAAAAANb_jArkWwUjSrkO0CgiZc33U-Fn",
    // subscriptionApi : "https://comic-dev.biospheres.game/api/subscribe",
    // //PROD
    // // recaptchaKey : "6LfrZ8giAAAAAF7A1OS4uVFQjBLgFljR0gt-etJ-",
    // // subscriptionApi : "https://biospheres.game/api/subscribe",


  },
})




// WEBPACK FOOTER //
// ./src/store.js